import L from "leaflet";
import React from "react";
import { Marker, Popup } from "react-leaflet";

interface Props {
  x: number;
  y: number;
  uuid: string;
  name: string;
}

const PlayerMarker: React.FC<Props> = ({ x, y, uuid, name }) => {
  const icon = new L.Icon({
    iconUrl: `https://mc-heads.net/avatar/${uuid}/25`,
    iconSize: [25, 25],
    iconAnchor: [12.5, 12.5],
    className: "rounded-md",
  });

  return (
    <Marker position={[y, x]} icon={icon}>
      <Popup>
        <div>
          <b>{name}</b>
        </div>
      </Popup>
    </Marker>
  );
};

export default PlayerMarker;
